import { MiqMoment } from '@miq/utils';
import { ExportExecutableParams } from '../export.model';

export const getPropertyDataForFileName = (propertyName: string, postalAddress: string) => {
  if (propertyName == null || postalAddress == null) {
    return propertyName ?? postalAddress;
  }

  const propertyNameLower = propertyName.toLowerCase();
  const postalAddressLower = postalAddress.toLowerCase();
  if (propertyNameLower.includes(postalAddressLower)) {
    return propertyName;
  }
  if (postalAddressLower.includes(propertyNameLower)) {
    return postalAddress;
  }

  return `${propertyName} ${postalAddress}`;
};

export const getFullFileName = (exportParams: ExportExecutableParams, desc?: string) => {
  const { propertyName, postalAddress } = exportParams?.propertyData ?? {};
  const downloadDate = MiqMoment.format(new Date(), 'YYYY-MM-DD');
  const initialDesc = desc != null && desc != '' ? `${desc} - ` : '';
  return `${initialDesc}${
    getPropertyDataForFileName(propertyName, postalAddress?.full_street_name) ?? exportParams.propertyId
  } - ${downloadDate}`;
};

export enum TemplateHubStatus {
  Completed = 'Completed',
  Pending = 'Pending',
  Failed = 'Failed',
  InProgress = 'InProgress',
}
